<template>
  <page-view :title="true">
    <a-card>
      <a-descriptions title="基本信息">
        <a-descriptions-item label="昵称">{{
          info.nickName
        }}</a-descriptions-item>
        <a-descriptions-item label="性别">{{ info.sex }}</a-descriptions-item>

        <a-descriptions-item label="认证状态">
          <a-badge
            :status="info.authSta | statusTypeFilter"
            :text="info.authSta | statusFilter"
          />
        </a-descriptions-item>
        <a-descriptions-item label="用户类型">
          <a-tag
            :color="
              info.userType == '1'
                ? ''
                : info.userType == '2'
                ? '#2db7f5'
                : '#f50'
            "
          >
            {{
              info.userType == "1"
                ? "普通用户"
                : info.userType == "2"
                ? "管家"
                : "商户"
            }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="签名" :span="3">{{
          info.signature
        }}</a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <a-descriptions title="联系方式">
        <a-descriptions-item label="手机号">{{
          info.mobile
        }}</a-descriptions-item>
        <a-descriptions-item label="邮箱">{{ info.email }}</a-descriptions-item>
      </a-descriptions>
      <a-divider />

      <div class="operation">
        <a-button @click="back">返回</a-button>
      </div>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
export default {
  components: {
    PageView
  },
  name: "UserInfo",
  data() {
    return {
      info: {}
    };
  },
  filters: {
    statusFilter(type) {
      let str = "已认证";
      if (type == "R") {
        str = "未认证";
      } else if (type == "X") {
        str = "认证失败";
      }
      return str;
    },
    statusTypeFilter(type) {
      let str = "success";
      if (type == "R") {
        str = "default";
      } else if (type == "X") {
        str = "error";
      }
      return str;
    }
  },
  created() {
    let query = this.$route.query;
    this.info = query.info;
  },
  methods: {
    back() {
      this.$router.push({
        name: "UserList"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.operation {
  text-align: center;
  margin: 20px auto 5px;
  button {
    margin: 0 10px;
  }
}
</style>
